var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('vessel-monitoring-single-hatch',{attrs:{"vesselHatch":_vm.vesselMonitoringData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }